import * as React from 'react';

function SvgDailyPriceCalcSpecificCalendarMonth(props) {
  return (
    <svg width={48} height={48} fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M33.375 14.25a.376.376 0 01-.375.375h-2.625A.376.376 0 0130 14.25V12H18v2.25a.376.376 0 01-.375.375H15a.376.376 0 01-.375-.375V12h-6v6.375h30.75V12h-6v2.25z"
        fill="transparent"
      />
      <path d="M41.25 8.625h-7.875v-3A.376.376 0 0033 5.25h-2.625a.376.376 0 00-.375.375v3H18v-3a.376.376 0 00-.375-.375H15a.376.376 0 00-.375.375v3H6.75c-.83 0-1.5.67-1.5 1.5V41.25c0 .83.67 1.5 1.5 1.5h34.5c.83 0 1.5-.67 1.5-1.5V10.125c0-.83-.67-1.5-1.5-1.5zm-1.875 30.75H8.625V21.562h30.75v17.813zm0-21H8.625V12h6v2.25c0 .206.169.375.375.375h2.625A.376.376 0 0018 14.25V12h12v2.25c0 .206.169.375.375.375H33a.376.376 0 00.375-.375V12h6v6.375z" />
    </svg>
  );
}

export default SvgDailyPriceCalcSpecificCalendarMonth;
